import React from 'react';
import { Card, CardBody, CardHeader, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Add, Contact, DangerColor, Hometxt, Modalcontent, nav_danger, Pillspan1, Profile } from '../../../../../../../Constant';
import { H5, P } from '../../../../../../../AbstractElements';
import TabsPreventDefaultAndAnimation from '../../../../../../../Hoc/TabsPreventDefaultAndAnimation';

const PillDangerTab = ({ show, tabActive, tabActiveHandler }) => {
  return (
    <Col sm='12' xl='6 xl-100'>
      <Card className='height-equal'>
        <CardHeader className='pb-0'>
          <H5>{DangerColor}</H5>
          <span>
            {Add} <code>{nav_danger}</code> {Pillspan1}
          </span>
        </CardHeader>
        <CardBody>
          <Nav className='nav-danger m-b-30'>
            <NavItem>
              <NavLink href='#javascript' className={tabActive === '1' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '1')}>
                <i className='icofont icofont-ui-home'></i>
                {Hometxt}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href='#javascript' className={tabActive === '2' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '2')}>
                <i className='icofont icofont-man-in-glasses'></i>
                {Profile}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href='#javascript' className={tabActive === '3' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '3')}>
                <i className='icofont icofont-contacts'></i>
                {Contact}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={tabActive}>
            <TabPane className={`fade ${tabActive === '1' ? show : ''}`} tabId='1'>
              <P className='mb-0'>{Modalcontent}</P>
            </TabPane>
            <TabPane className={`fade ${tabActive === '2' ? show : ''}`} tabId='2'>
              <P className='mb-0'>{Modalcontent}</P>
            </TabPane>
            <TabPane className={`fade ${tabActive === '3' ? show : ''}`} tabId='3'>
              <P className='mb-0'>{Modalcontent}</P>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TabsPreventDefaultAndAnimation(PillDangerTab);
